<template>
  <!-- Products -->
  <div>
    <h4 class="font-weight-500 my-2">{{ $t('table.products') }}</h4>
    <div class="d-flex justify-content-space-between">
      <el-checkbox
        v-if="editMode"
        v-model="isOneLineEditModeOn"
        class="pl-2"
      >{{ $t('table.oneLineEdit') }}</el-checkbox>
      <el-button
        v-if="!isOneLineEditMode"
        type="info"
        @click="handleAddProductItem"
      >{{ $t('button.addNewItem') }}</el-button>
    </div>

    <el-form-item
      v-if="isOneLineEditMode"
      :label="$t('table.id')"
      :rules="rules.idList"
      prop="product_ids"
    >
      <el-input
        :value="value"
        clearable
        @input="updateInputProduct"
      />
      <div class="one-line-image">
        <template
          v-for="productId in value.split(',')"
        >
          <img
            v-if="productImages[productId]"
            :key="`product-image-${productId}`"
            :src="productImages[productId]"
            class="product-image"
          >
        </template>
      </div>
    </el-form-item>
    <el-table
      v-else
      :data="value"
      row-key="key"
    >
      <!-- Product ID Field -->
      <el-table-column
        :label="$t('table.id')"
        align="center"
        min-width="200"
      >
        <template #default="{ row, $index }">
          <el-form-item
            :label="`Product ${$index + 1} ID`"
            :prop="`product_ids.${$index}.id`"
            :rules="rules.requiredId"
          >
            <el-input
              v-model.trim="row.id"
              clearable
            />
          </el-form-item>
        </template>
      </el-table-column>
      <!-- Product ID Field -->

      <!-- Product Image Preview -->
      <el-table-column
        v-if="hasProductImage"
        :label="$t('table.image')"
        align="center"
        width="120"
      >
        <template #default="{ row }">
          <img
            :src="row.img"
            class="product-image"
          >
        </template>
      </el-table-column>
      <!-- Product Image Preview -->

      <!-- Delete Button -->
      <el-table-column
        :label="$t('table.action')"
        align="center"
        width="60"
      >
        <template #default="{ $index }">
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDeleteProductItem($index)"
          />
        </template>
      </el-table-column>
      <!-- Delete Button -->

      <!-- Drag Button -->
      <el-table-column
        align="center"
        label="Drag"
        width="55"
      >
        <span class="drag-handler mt-1">
          <font-awesome-icon
            class="drag"
            icon="arrows-alt"
          />
        </span>
      </el-table-column>
      <!-- Drag Button -->
    </el-table>
  </div>
  <!-- Products -->
</template>

<script>
import Sortable from 'sortablejs'

import { FormRules } from '../../utils/form'
import { getRandomHash } from '../../utils/helper'

export default {
  name: 'ProductSelector',
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Array, String],
      required: true,
    },
  },
  data() {
    return {
      isOneLineEditModeOn: !this.editMode,
      rules: {
        idList: [FormRules.idList],
        requiredId: [FormRules.id, FormRules.required],
      },
      productImages: {},
    }
  },
  computed: {
    isOneLineEditMode() {
      return !this.editMode || this.isOneLineEditModeOn
    },
    hasProductImage() {
      return Array.isArray(this.value)
        ? this.value.some(product => !!product.img)
        : false
    },
  },
  watch: {
    value() {
      this.setSort()
    },
    isOneLineEditModeOn(value) {
      if (value) {
        this.updateInputProduct(this.value.map(({ id }) => id).join(','))
      } else {
        this.updateInputProduct(this.value.split(',').map(id => ({
          id,
          // img: this.productImages[id],
          key: getRandomHash(),
        })))
        this.$nextTick(() => {
          this.setSort()
        })
      }
    },
  },
  methods: {
    updateInputProduct(productIdsString) {
      this.$emit('input', productIdsString)
    },
    handleAddProductItem() {
      this.updateInputProduct([...this.value, {
        key: getRandomHash(),
        id: '',
      }])
      this.$nextTick(() => {
        this.setSort()
      })
    },
    handleDeleteProductItem(index) {
      const result = [...this.value]
      result.splice(index, 1)
      this.updateInputProduct(result)
    },
    setSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      if (!el) return
      this.sortableObject = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        handle: '.drag-handler',
        setData(dataTransfer) {
          dataTransfer.setData('Text', '')
          // to avoid Firefox bug
          // Detail see : https://github.com/RubaXa/Sortable/issues/1012
        },
        onMove: (evt) => {
          // disable drag & drop while saving
          if (this.isSaving) {
            evt.preventDefault()
            return false
          }
          return true
        },
        onEnd: (evt) => {
          const result = [...this.value]
          const targetRow = result.splice(evt.oldIndex, 1)[0]
          result.splice(evt.newIndex, 0, targetRow)
          this.updateInputProduct(result)
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
